//
//
//
//
//
//
import NcsGlobalOption from './NcsGlobalOption';
export default {
  "extends": NcsGlobalOption
};